import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { MenuOutlined as MenuIcon } from '@mui/icons-material';
import { useTheme } from '@emotion/react';

const TrayToggleButton = ({ onClick, open = false }) => {
  const theme = useTheme();

  return (
    <Tooltip title={open ? "Close sidebar" : "Open sidebar"}>
      <IconButton
        onClick={onClick}
        sx={{
          position: 'fixed',
          top: 16,
          left: 16,
          zIndex: theme.zIndex.fab,
        }}
      >
        <MenuIcon fontSize="medium" sx={{ color: `${theme.palette.icon.primary}` }} />
      </IconButton>
    </Tooltip>
  );
};

export default TrayToggleButton;